import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef } from "react";
import { useReportWebVitals } from "next/web-vitals";
import { reportWebVital } from "@/lib/reportWebVital";
const REPORTED_VITALS = ["INP", "LCP", "TTFB", "CLS"];

/**
 * Reports the page's web vitals (INP, LCP, TTFB, CLS) to `/frontend/metrics`
 * so they chart over time in Grafana, labeled by the pages-router route
 * pattern (e.g. `/[org]/logs`).
 *
 * web-vitals emits INP and CLS when the page is first hidden (tab switch,
 * close) and again on later hides if the value grew; only the first emission
 * per metric id is reported, since a Prometheus histogram cannot retract the
 * earlier sample.
 */
export function useWebVitalsReporting() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Set();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const reportedIds = useRef(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = metric => {
      if (!REPORTED_VITALS.includes(metric.name)) {
        return;
      }
      if (reportedIds.current.has(metric.id)) {
        return;
      }
      reportedIds.current.add(metric.id);
      reportWebVital(metric.name, metric.value);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useReportWebVitals(t1);
}